import {useClient} from '@adamlip/okeoke.client';
import FormattedNumber from 'components/FormattedNumber';

function OrderViewItems({item}) {
	const {getName} = useClient();

	return (
		<div className='w-full rounded-md flex flex-col justify-between items-center  bg-background border-2 border-border'>
			<div className='w-full rounded-md flex flex-row justify-between items-center p-2 bg-background'>
				<div className='basketItem-name  text-md'>
					{item?.count}x {`${getName(item?.name)}`}
				</div>
				<FormattedNumber value={+item.discountPrice} />
			</div>
			{item?.modifiers?.filter((mod) => mod?.count > 0)?.length > 0 && (
				<div className='w-full flex flex-col pl-4 text-sm pb-2'>
					{item?.modifiers
						?.filter((mod) => mod?.count > 0)
						?.map((mod) => (
							<div className='w-full flex flex-col' key={mod?.orderModifierUUID}>
								<div className='w-full rounded-md flex pl-2 flex-row justify-between items-center  bg-background'>
									<div className='grow truncate text-md'>
										{mod?.count}x {`${getName(mod?.name)}`}
									</div>
								</div>
							</div>
						))}
				</div>
			)}
		</div>
	);
}

export default OrderViewItems;
